import React from 'react';
import { ReactNode } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';



// ************************************ HOME PAGE ************************
// import   HomePage_v01    from '../component-library/HomePage_v01_Component';

import  HomePage_LegacyInsurance    from './HomePage_v02_TwoRows_LegacyInsurance';
import { AppConfig_DATA  } from "./App_v01_LegacyInsurance_ConfigData";
// ************************************ HOME PAGE ************************



import NavBar_v03Responsive from '../component-library/NavBar_v03a_Responsive_component';
import Footer from "../component-library/Footer_v01a_component";
import About_v01 from '../component-library/AboutUs_Page_v01-component';
import Services_v01 from '../component-demos/stash/Services_v01';
//  CUSTOM SECTION - NEEDED TO ADD ATRIUM NAME ON THE PAGE 
import Contact_LegacyInsurance_v02_A2P_v02 from './StandardPages/ContactUs_Page_LegacyInsurance_v02_A2P_v02';
// import Contact_v01 from '../component-library/ContactUs_Page_v01_component';



// import MortgageReadyScoreCardLanding_chat_05  from "../component-demos/MORTGAGE-BUSINESS/MortgageReadyScoreCard_v01_chat_05";
// import MortgageReadyScoreCardLanding_v01a  from "../component-demos/MORTGAGE-BUSINESS/MortgageReadyScoreCard_v01a_chat_05";
// import AutoInsuranceScoreCardLanding_v01_chat from "../component-demos/MORTGAGE-BUSINESS/AutoInsurance-ScoreCard_v01a_chat_05";


import EasyEmailSetupLanding_2025_11_07_chat from "../component-demos/EasyEMailSetup.com/EasyEmailSetupLanding_2025_11_07_chat";


//VOICE 
// import VoiceAgent365LandingPage_2025_12_15 from '../VoiceAgent365/stash/VoiceAgent365LandingPage_2025_12_15_chat'
// import VoiceAgent365LandingPage_2025_12_15_chat_v02 from '../VoiceAgent365/stash/VoiceAgent365LandingPage_2025_12_15_chat_v2'
// import VoiceAgent365LandingPage_2025_12_15_chat_v03 from '../VoiceAgent365/stash/VoiceAgent365LandingPage_2025_12_15_chat_v3'
// import VoiceAgent365LandingPage_2025_12_15_chat_v04 from '../VoiceAgent365/stash/VoiceAgent365LandingPage_2025_12_15_chat_v4'
// import VoiceAgent365LandingPage_2025_12_15_chat_v05 from '../VoiceAgent365/stash/VoiceAgent365LandingPage_2025_12_15_chat_v5'

// import VoiceAgent365LandingPage_2025_12_15_chat_v05_api from '../VoiceAgent365/ACTIVE-VoiceAgent365LandingPage_2025_12_15_chat_v5-api'

// import VoiceAgent365LandingPage_2025_12_15_chat_v06 from '../VoiceAgent365/VoiceAgent365LandingPage_2025_12_15_chat_v6'
// import VoiceAgent365LandingPage_2025_12_15_chat_v07 from '../VoiceAgent365/VoiceAgent365LandingPage_2025_12_15_chat_v7'



// import LandingPage_2025_12_15_gemini from '../VoiceAgent365/stash/VoiceAgent365LandingPage_2025_12_15_gemini'

//TRASH
import EasyTrashOutLandingPage_10_06_2025 from '../easy-trash-out/ETO-Demo-components/gemini-landing-page-10-06-2025';
import EasyTrashOut_QuoteManager_v01_Gemini from '../component-demos/EASY-TRASH-OUT/EasyTrashOut_QuoteManager_v01_gemini_2025_10_22';
import EasyTrashOut_LandingPage_v01_gemini_2025_10_17 from '../component-demos/EASY-TRASH-OUT/LandingPage_v01_gemini_2025_10_17';


//BINGO
import BingoGamePrint_2025_12_11_chat_v01 from '../component-demos/BINGO/BingoGamePrint_2025_12_11_chat_v01';


//aws 
import AWSLeadershipLandingPage_2025_12_09_CHAT from "../component-demos/AWSFanClub/AWSLeadership_LandingPage_2025_12_09_Chat"
import AWSLeadershipTeam_LandingPage_2025_12_09_Chat from "../component-demos/AWSFanClub/AWSLeadershipTeam_LandingPage_2025_12_09_Chat"

//BIG POSTCARD
import BigPostcardLandingPage_2025_11_21_chat from '../component-demos/BIG-POSTCARD-MARKETING/BigPostCardMarketingCO_2025_11_21_chat';


//BOUNCE HOUSE 
import BounceHouseLandingPage_2025_11_21_chat from '../component-demos/BOUNCE-PARTY/BounceParty_Landing_2025_11_21_chat';
import BounceHouseReservationPage_2025_11_21_chat from '../component-demos/BOUNCE-PARTY/BounceParty_Reservation_Page_2025_11_21_chat';

//JOE AWS 
import AWSConsultantLanding_2025_11_07 from "../component-demos/JOEAWS/joeAWSLaninging_v01_2025_11_07_chat"

//lifetime customer programs
import TrueLifetimeCustomerLandingPage_2025_11_30_chat from "../component-demos/TrueLifeTimeCustomer/TrueLifeTimeCustomerLanding_2025_11_30_chat";


//EASY LAUNDRY RENTAL 
import  AppEasyLaundryRental   from "../component-demos/EasyLaundryRental.com/EasyLaundryRental_Landing_v01_chat-2025-05-11";


//365VOICEAGENT
import Landing365AnsweringService_2025_12_10_chat from "../component-demos/365VoiceAgent/365VoiceAgent_LandingPage_2025_12_10_chatgpt"

//MORTGAGE READY
import MortgageReadyScoreCardLandingPage_2025_11_06 from "../component-demos/MORTGAGE-BUSINESS/MortgageReadyScoreCard_v02-chat_2025_11_06";

//DIVORCE READY
import DivorceReadyScoreCardLandingPage_2025_11_07_chat from "../component-demos/DIVORCE-READY/DivorceReadyScoreCard_2025_11_07_chat";

//FLASH CARD APP 
import  FLASH_CARD_APP  from "../component-demos/FLASH-CARD-COMPONENTS/FlashCard-APP-NOV-2025_v01_gemini";

// MYTH BUSTER 
import { MythVsFactCarInsuranceQuizWizard_v01 } from "./MythBuster/MythBusterQuiz_v01";




import TestPage_v01 from '../sundance-vending/components/TestPage_v01';
import TestCreditCardComponent from '../component-library/CreditCardComponent_v01_test'
import CreditCardManager from '../ScoreCards/SmartMoneyCredit/CreditManager/CreditCardManager_v01'
import FAQs_Page_v01_MASTER_WithSUB from '../component-library/MASTER-COMPONENTS/FAQ_Page_v01_MASTER_WithSUB';
import LeftSideNavScrollSpy_v03 from '../component-demos/LeftSideNavBarScorllSpy_v03';

// PERSONAL INSURANCE AND BUSINESS INSURNACE 
import BizServicesListImagesMultiColumn_v03 from "../component-library/BizServicesListImagesMultiColumn_v03";











//LEGAL & SECURITY  = LEGACY INSURANCE 
import { ContactFormWithCaptcha_TEST } from '../component-library/reactCA';
import TermsOfServiceLegacyInsurance from './StandardPages/LEGAL_TOS_LegacyInsurance_v01_A2P';
import PrivacyPolicy from './StandardPages/LEGAL_PrivacyPolicy_LegacyInsurance_v02_A2P';














//DEMOS 
import ChatBot from "../component-library/ChatBOT_v01_component";

import SantasWorkshopLetter from '../SantaLetters/SantaLetter_01';
import App_Santa_v01 from '../SantaLetters/SantaLetter_Gemini_01';
import App_Santa_v02 from '../SantaLetters/SantaLetter_Gemini_02_MultiChild';
// import SantasWorkshopLetter from '../SantaLetters/SantaLetter_0';
// import SantasWorkshopLetter from '../SantaLetters/SantaLetter_01';

import TaxChecklist from './TAX-DEMO-COMPONENTS/Tax-Checklist_v01';



import AboutLegacyInsurance from './StandardPages/AboutLegacyInsurance_Page_v01';
import AboutLegacyInsurance_v02 from './StandardPages/AboutLegacyInsurance_Page_v02a';
import AboutLegacyInsurance_v03 from './StandardPages/AboutLegacyInsurance_Page_v03';

import CardListDemoPage from '../component-demos/CardAndListDemo_Page_v01';

import  WindowScoreCardQuiz   from "../Windows/WindowsQuiz_v01";

import BossScoreCard from "../ScoreCards/hostingScoreCard.com/BossScoreCard/BossScoreCard-component";

import InsuranceExample from './stash/Examples-component_v01';
import InsuranceExample2 from './stash/Examples-component_v02';
import InsuranceExample3 from './InsuranceExamples-component_v03';

import FamilyInsuranceScoreCard from './scoreCardComponents/FamilyInsuranceScoreCard_v01';
import BusinessInsuranceScoreCard from './scoreCardComponents/BusinessIsuranceScoreCard_v01';

import CustomEdgeFabricationLanding from '../Custom-Edge-Fabrication/HomePage_v01-CustomEdge';

import InsuranceLookup from './InsuranceLookup-component';
import InsuranceLookup_v02 from './InsuranceLookup-component_v02';

import InsuranceLookup_v03  from './InsuranceLookup-component_v03-cardAndExample';
import InsuranceLookup_v04 from './InsuranceLookup-component_v04-cardAndExample';
import InsuranceLookup_v05 from './InsuranceLookup-component_v05-cardAndExample'


import BrokerBenefits_v01 from './BrokerBenefits_v01';
import BrokerBenefits_v02 from './BrokerBenefits_v02';
import BorkerBenefits_v03 from './BrokerBenefits_v03';

import  InsuranceQuoteForm from "./QuoteForms/RequestAQuote_v01";

// import { InsuranceQuoteForm_Gemini_v01 } from "./QuoteForm-Gemini/QuoteForm-Gemini";


import { DUI_QuoteWizard_v01g  } from "../xDUIInsurance/dui-wizard/DUIAutoInsurance_wizard_v01g";
import { ExampleDuiQuoteWizard_H7  } from "../xDUIInsurance/dui-wizard/DUIAutoInsurance_wizard_v01H7";
import { ExampleDuiQuoteWizard_H8  } from "../xDUIInsurance/dui-wizard/DUIAutoInsurance_wizard_v01H8";








//DUI QUTOE WIZARDS --------------------------------------------------------------------------------------------

import { DUIInsurance_Benefits_v01 } from "../component-demos/DUI-Insurance/DUI_Benefits_v01";


//import { ExampleDuiQuoteWizard_H8  } from "../DUIInsurance/dui-wizard/";
import { ExampleQuoteWizard_H9  } from "../xDUIInsurance/dui-wizard/DUI_and_AUTO_AutoInsurance_wizard_v01H9";
import { AutoDUI_QuoteWizard_H10  } from "../xDUIInsurance/dui-wizard/DUI_and_AUTO_InsuranceQuote_wizard_v01H10";
import { AutoDUI_QuoteWizard_H11a  } from "../xDUIInsurance/dui-wizard/DUI_and_AUTO_InsuranceQuote_wizard_v01H11a";


import { EasyDuiLandingPage_v01  } from "../component-demos/DUI-Insurance/DUILandingPage_v01";
import { EASY_DUI_LandingPage_v02 } from "../component-demos/DUI-Insurance/DUILandingPage_v02";
import { EASY_DUI_LandingPage_v02a } from "../component-demos/DUI-Insurance/DUILandingPage_v02a";

import { EASY_DUI_LandingPage_v02b } from "../component-demos/DUI-Insurance/DUILandingPage_v02b";
import { EASY_DUI_LandingPage_v02c } from "../component-demos/DUI-Insurance/DUILandingPage_v02c";
import { EASY_DUI_LandingPage_v02c_WIZARD } from "../component-demos/DUI-Insurance/DUILandingPage_v02c_WIZARD";
import { EASY_DUI_LandingPage_v02d_WIZARD } from "../component-demos/DUI-Insurance/DUILandingPage_v02d_WIZARD";
import { EASY_DUI_LandingPage_v02e_WIZARD } from "../component-demos/DUI-Insurance/DUILandingPage_v02e_WIZARD";
import { EASY_DUI_LandingPage_v02f_WIZARD } from "../component-demos/DUI-Insurance/DUILandingPage_v02f_WIZARD";
import { EASY_DUI_LandingPage_v02g_WIZARD } from "../component-demos/DUI-Insurance/DUILandingPage_v02g_WIZARD";
import { EASY_DUI_LandingPage_v02h_WIZARD } from "../component-demos/DUI-Insurance/DUILandingPage_v02h_WIZARD";

import { EASY_DUI_LandingPage_v02K_WIZARD } from "../EasyDUI-Insurance/DUILandingPage_v02k_WIZARD";

import { DUI_InsuranceLanding_v04_Carousel } from "../component-demos/PET-INSURANCE/DUI_Insurance_v04_Carousel";
import  DUIInsuranceLandingPage_v05  from "../component-demos/DUI-Insurance/DUILandingPage_v05_Carousel";




































// RENTERS INSURANCE 
// ---------------------------------------------------------------------------------------------------------
import { EASY_RENTERS_LandingPage_v01_WIZARD } from "../component-demos/DUI-Insurance/RentersIns_LandingPage_v02h_WIZARD";
import { EASY_RENTERS_LandingPage_v02i_WIZARD } from "../component-demos/DUI-Insurance/RentersIns_LandingPage_v02i_WIZARD";
import { EASY_RENTERS_LandingPage_v02j_WIZARD } from "../component-demos/DUI-Insurance/RentersIns_LandingPage_v02j_WIZARD";
import { EASY_RENTERS_LandingPage_v02k_WIZARD } from "../component-demos/DUI-Insurance/RentersIns_LandingPage_v02k_WIZARD";
import { EASY_RENTERS_LandingPage_v02L_WIZARD } from "../component-demos/DUI-Insurance/RentersIns_LandingPage_v02L_WIZARD";
import { EASY_RENTERS_LandingPage_v02M_WIZARD } from "../component-demos/DUI-Insurance/RentersIns_LandingPage_v02M_WIZARD";
import { EASY_RENTERS_LandingPage_v02N_WIZARD } from "../component-demos/DUI-Insurance/RentersIns_LandingPage_v02N_WIZARD";
import { EASY_RENTERS_LandingPage_v02O_WIZARD } from "../component-demos/DUI-Insurance/RentersIns_LandingPage_v02O_WIZARD";
import { EASY_RENTERS_LandingPage_v02P_WIZARD } from "../component-demos/DUI-Insurance/RentersIns_LandingPage_v02P_WIZARD";
import { EASY_RENTERS_LandingPage_v02O_01_WIZARD } from "../component-demos/DUI-Insurance/RentersIns_LandingPage_v02O_01_WIZARD";

















// WELDING -----------------------------------------------------------------------------------------------------------------
import { DISCOUNT_WELDING_LandingPage_v020_WIZARD }   from "../component-demos/DUI-Insurance/WeldingInsur_LandingPage_v02O_WIZARD";
import { DISCOUNT_WELDING_LandingPage_v020b_WIZARD }   from "../component-demos/DUI-Insurance/WeldingInsur_LandingPage_v02Ob_WIZARD";






// PAINTING
// PLUMBERS 
// ELECTRICIAN
// SOLAR
// PARKING LOT STRIPE
// JEWELRY 

import { EASY_PAINTING_LandingPage_v02O_WIZARD }      from "../component-demos/DUI-Insurance/PAINTER_Insur_LandingPage_v02O_WIZARD";
import { DISCOUNT_JEWELRY_Landing_v020_WIZARD }       from "../component-demos/DUI-Insurance/JEWELRY_LandingPage_v02O_WIZARD";
import { DISCOUNT_PLUMBERS_LandingPage_v02O_WIZARD }  from "../component-demos/DUI-Insurance/PlumbersInsur_LandingPage_v02O_WIZARD";
import  DISCOUNT_PAINTERS_LandingPage_v01_WIZARD   from "../component-demos/PAINTERS-INSURANCE/DISCOUNT_PAINTERS_LandingPage_v01_WIZARD_CHAT_2025_11_25";




// SOLAR
import { CERTIFIED_SOLAR_REPORT_Landing_v02O_WIZARD }  from "../component-demos/DUI-Insurance/SOLAR-home-report_LandingPage_v02O_WIZARD";

import { SOLAR_5080_LandingPage_v01 } from "../SOLAR/SOLAR_5080_LandingPage_v01";


//FUNNELS

import  AutoInsuranceQuoteFunnel_2025_11_27_chat from "../Insurance-Legacy/INSURANCE-FUNNELS/AutoInsuranceQuoteFunnel"


import { DENVER_ParkingLotStriping_Landing_v01_WIZARD }  from "../component-demos/DUI-Insurance/ParkingLotStripe_LandingPage_v02O_WIZARD";

import { EASY_CONTRACTOR_LandingPage_v02O_WIZARD }  from "../component-demos/DUI-Insurance/EasyContractorsInsurance_LandingPage_v02O_WIZARD";

import { DISCOUNT_ELECTRICIAN_LandingPage_v020c_WIZARD }  from "../component-demos/DUI-Insurance/ElectricianInsurance_LandingPage_v02O_01_WIZARD";






// GENERIC DEMOS 
import { FourStepWizardForm_v01 } from "../component-demos/DUI-Insurance/DEMO_FORM_4_STEP";



//CONTRACTOR
import { DISCOUNT_CONTRACTOR_LandingPage_v02K_WIZARD } from "../component-demos/DUI-Insurance/EasyContractorInsurance_LandingPage_v02k_WIZARD";
import { EASY_CONTRACTOR_LandingPage_v03  } from "../easy-contractor/EasyContractor_Landing_v03";
import { EASY_CONTRACTOR_LandingPage_v03a  } from "../easy-contractor/EasyContractor_Landing_v03a";
import { EASY_CONTRACTOR_LandingPage_v03b  } from "../easy-contractor/EasyContractor_Landing_v03b";


// HOT TUB 
// WINDOWS
import { HotTubQuiz_Landing_v01  } from "../component-demos/DUI-Insurance/HotTub-Quiz_v01";


// RESTAURANT 
import { RestaurantFeedbackWizard_H11aStyled } from "../component-demos/BUSINESS-FEEDBACK-FORMS/Restaurant-feedback-v01a";
// auto shopt
import { AutoShopFeedbackWizard_H11bStyled } from "../component-demos/BUSINESS-FEEDBACK-FORMS/AutoShop-feedback-v01a";







import { ExampleContractorWizard_C2  } from "../component-demos/INSURANCE-FORMS/Contractor-work-comp_v01";

// PAINTING 
import { ExamplePaintingWizard_P1  } from "../component-demos/INSURANCE-FORMS/Contractor-painting_v01";
import { PaintingContractorInsuranceLanding } from "../component-demos/INSURANCE-FORMS/PaintingContractor-landingPage";



// MOTOR CYCLE
import { Motorcycle_QuoteWizard_H2a } from "./QuoteForms/MotorCycle-Insurnace-Quote_v01a";


// CONTRACTOR

import { ExampleContractorWizard_C1  } from "./QuoteForms/ContractorQuoteForm_v01a";
import { Contractor_QuoteWizard_H2 } from "./QuoteForms/Contractor-Insurance-Quote_v01";
import { Contractor_QuoteWizard_H2_A } from "./QuoteForms/Contractor-v2-demos/Contractor-insurance-quote-v01A-example";
import { Contractor_QuoteWizard_H2_B } from "./QuoteForms/Contractor-v2-demos/Contractor-insurance-quote-v01B-example";


// RENTERS
import { Renters_QuoteWizard_H2 } from "./QuoteForms/Renters-Insurance/Renter-Insurance_v01";
import { Renters_Insurance_v02 } from "./QuoteForms/Renters-Insurance/Renters-Insurance_v02";
import { Renters_Insurance_v03 } from "./QuoteForms/Renters-Insurance/Renters-Insurance_v03";
import { RentersInsuranceLandingPage_v01  } from "./QuoteForms/Renters-Insurance/Renters-Insurance-LandingPage_v01";



// AUTO INSURANCE
import { AUTO_Insurance_Wizard_v06 } from "../component-demos/DUI-Insurance/DEMO_WIZARD_V06-SEP-05-2025-AUTO";
// HOME INSURANCE 
import { HOME_Insurance_Wizard_v06 } from "../component-demos/DUI-Insurance/HOME_Insurance_Wizard_v06";
import { HOME_Insurance_Wizard_v06a_Themes } from "../component-demos/DUI-Insurance/HOME_Insurance_Wizard_v06a-Themes";
import { HOME_Insurance_Wizard_v06b_Themes } from "../component-demos/DUI-Insurance/HOME_Insurance_Wizard_v06b-Themes";




// DEMO - US MAP 
import  USMapInteractive   from "../component-demos/US-MAP-DEMOS/US-Map-demo_v01";

// VIDEO WIZARD 
import  DualViewWizard_Vending_H2  from "../component-demos/Vending/Vending-quote-v01";
import {VendingInterest_v03} from "../component-demos/Vending/Vending-CustomerInterest-v03"


// SALES FORCE
import DenverSalesforceLandingPage_v01 from "../component-demos/SalesForce-demo/DenverSalesForceLandingPage_v01"


import { EasyButtonInsuranceLandingPage_v01 } from "../component-demos/EASY-BUTTON-INSURANCE/EasyButtonInsuranceLandingPage_v01";

import  SOLAR_5280_LandingPage_v01   from "../component-demos/SOLAR-DEMOS/Solar_5280_LandingPage_v01";




// PET 
import { DollarPetInsuranceLanding_v02 } from "../component-demos/PET-INSURANCE/PetInsurance_v02";
import { PetInsuranceLanding_v03_Carousel }   from "../component-demos/PET-INSURANCE/PetInsurance_v03_Carousel";
import { PetInsuranceLanding_v03a_Carousel }  from "../component-demos/PET-INSURANCE/PetInsurance_v03a_Carousel";
import { PetInsuranceLanding_v04_Carousel }   from "../component-demos/PET-INSURANCE/PetInsurance_v04_Carousel";
import { PetInsuranceLanding_v05_Carousel }   from "../component-demos/PET-INSURANCE/PetInsurance_v05_Carousel";
import { PET_Insurance_TOPICS_Page_Example_v01  } from "../component-demos/PET-INSURANCE/BENEFTIS-COMPONENT/PET-Insurance-topic-example-page_v01";










import { SecretShopperTeamLanding_v01 } from "../component-demos/SECRET-Shopper/SecretShopperLandingPage";


// import { DUIInsuranceDocView_v01  } from "../component-demos/BASIC-INSURACE-INFO-OBJECT/DUIInsuranceInfoView_v01";

// import {  } from "../component-demos/BASIC-INSURACE-INFO-OBJECT/INFO_INSURANCE_INFO_DISPLAY_v01";
import { hvacInsurance } from "../component-demos/BASIC-INSURACE-INFO-OBJECT/INFO_HVAC_Insurance_v01";


import InsuranceCard_v01 from "../component-demos/BASIC-INSURACE-INFO-OBJECT/INFO_INSURANCE_INFO_DISPLAY_v01"
// import InsuranceCard from "../components/InsuranceCard";

import { ReactFourTabs_v01 } from "../component-demos/React-Bootstrap-demos/React-TabDemo_v01";


import { React_Tabs_v01_NavHeaderFooter } from "../component-demos/React-Bootstrap-demos/React-TabDemo_v02-NavHeaderFooter";
import { TabsWithLeftOffcanvas_v03 } from "../component-demos/React-Bootstrap-demos/React-TabDemo_v03-NavHeaderFooter";

import { TabsWithLeftOffcanvas_v04  } from "../component-demos/React-Bootstrap-demos/React-TabDemo_v04-NavHeaderFooter";


// POWER WASH
import { PowerWashLandingCarousel_v01  } from "../component-demos/POWERWASH-SERVICE-BIZ/PowerWashLanding_v01";
import { PowerWashingLanding_v05_Carousel } from "../component-demos/POWERWASH-SERVICE-BIZ/PowerWashingLanding_v05_carousel";



// TAX 
import { TAX_DeepDive_Landing_v05_Carousel } from "../component-demos/TAX-DEEP-DIVE/TaxDeepDive_v01";
import { TAX_DEEP_DIVE_LandingPage_v02O } from "../component-demos/TAX-DEEP-DIVE/TAX_DEEP_DIVE_LandingPage_v02O";

// INSURANCE WIZARD
import { INSURANCE_WizardLanding_v01 } from "../component-demos/DUI-Insurance/INSURANCE_WizardLanding_v01";

// CONTRACTOR 
import { EASY_CONTRACTOR_LandingPage_v01_WIZARD } from "../component-demos/DUI-Insurance/CONTRACTOR_InsuranceLanding_WIZARD_v01";





// BASIC DEMOS 
import { WIZARD_RightToLeft_v01 } from "../component-demos/DUI-Insurance/DEMO_WIZARD_V01-SEP-05-2025";
import { WIZARD_RightToLeft_v02 } from "../component-demos/DUI-Insurance/DEMO_WIZARD_V02-SEP-05-2025";
import { WIZARD_RightToLeft_v03 } from "../component-demos/DUI-Insurance/DEMO_WIZARD_V03-SEP-05-2025";
import { WIZARD_RightToLeft_v04 } from "../component-demos/DUI-Insurance/DEMO_WIZARD_V04-SEP-05-2025";
import { WIZARD_RightToLeft_v05 } from "../component-demos/DUI-Insurance/DEMO_WIZARD_V05-SEP-05-2025";
import { WIZARD_RightToLeft_v06 } from "../component-demos/DUI-Insurance/DEMO_WIZARD_V06-SEP-05-2025";






import { IAppConfig } from "../App_v01_Interfaces";

interface AppConfigProps{
  appConfig: IAppConfig;
}

//import IBusinessServicesDataProps from "../component-library/BizServicesListImagesMultiColumn_v03";


const AppRouts_v01: React.FC = () => {

  return (
    <Router>
            <div className="d-flex flex-column min-vh-100 justify-content: flex-start">
              <NavBar_v03Responsive appConfig={AppConfig_DATA} />
                <main className="flex-fillx">
                  <Routes>
                      <Route path="/" element={<HomePage_LegacyInsurance appConfig={AppConfig_DATA} />} />
                      <Route path="*" element={<HomePage_LegacyInsurance appConfig={AppConfig_DATA} />} />
                      <Route path="/faq" element={<FAQs_Page_v01_MASTER_WithSUB  faqDataDocument={AppConfig_DATA.faqData} />} />
                      {/* <Route path="/about" element={<About_v01    appConfig={AppConfig_DATA} />} /> */}
                      <Route path="/about" element={<AboutLegacyInsurance_v03 />} />

                      <Route path="/contact" element={<Contact_LegacyInsurance_v02_A2P_v02 appConfig={AppConfig_DATA} />} />
                    
                      <Route path="/businessInsurance" element={<BizServicesListImagesMultiColumn_v03 bizServicesData={AppConfig_DATA.ServicesPage1} />} />
                      <Route path="/personalInsurance" element={<BizServicesListImagesMultiColumn_v03 bizServicesData={AppConfig_DATA.ServicesPage2} />} />
                      <Route path="/tos" element={<TermsOfServiceLegacyInsurance />} /> 
                      <Route path="/privacy" element={<PrivacyPolicy />} />
                      
                      {/* 
                        <Route path="/broker1" element={<BrokerBenefits_v01 />} />
                        <Route path="/broker2" element={<BrokerBenefits_v02 />} />
                      */}
                      <Route path="/broker" element={<BorkerBenefits_v03 />} />









                      {/* DEMO COMPONENTS  */}
                      <Route path="/services" element={<Services_v01 appConfig={AppConfig_DATA} />} />
                      <Route path="/leftnav" element={<LeftSideNavScrollSpy_v03 />} />\
                      <Route path="/googleSPDemov01" element={<LeftSideNavScrollSpy_v03 />} />
                      <Route path="/chatBot" element={<ChatBot />} /> 
                      
                      {/* EFFECTS TEST PAGE */}
                      <Route path="/effects_test_page" element={<TestPage_v01 appConfig={AppConfig_DATA} />} />

                    
      
                      {/* COOLV LIST WITH SORTING AND FILTERING AND TABLE VS CARD VIEW */}
                      <Route path="/testcreditcardcomponent" element={<TestCreditCardComponent  />} />
                      
                      {/* SCORE CARDS QUIZ */}
                      <Route path="/WindowsQuiz" element={<WindowScoreCardQuiz />} />
                      {/* MY BOSS SCORE CARD QUIZ */}
                      <Route path="/bossscorecard" element={<BossScoreCard />} />\



                      {/* COMPONENT READING  */}
                      <Route path="/example" element={<InsuranceExample />} />
                      <Route path="/example2" element={<InsuranceExample2 />} />
                      {/* EXAMPLE 3 - GOOD - STRINGS EXTERNALIZED IN JSON AND TITLE NOT HARD */}
                      <Route path="/example3" element={<InsuranceExample3 />} />






                      {/* OK BUSINESS INSURANCE SCORE CARD */}
                      <Route path="/businessInsurance_Scorecard" element={<BusinessInsuranceScoreCard />} />


                      {/* FAMILY SCORE CARD */}
                      <Route path="/familyscorecard" element={<FamilyInsuranceScoreCard />} />



                      {/* BASIC LANDING PAGE - CUSTOM EDGE FABRICATION  */}
                      <Route path="/customedge" element={<CustomEdgeFabricationLanding />} />

                      <Route path="/CardListDemo" element={<CardListDemoPage />} />
                      


                      {/* BASIC JSON DOCUMENT LOOKPU - WORKS - biz-004 */}
                      <Route path="/insurancelookup" element={<InsuranceLookup />} />


                      {/* LOOKUP WITH DROP DOWN */}
                      <Route path="/insurancelookup2" element={<InsuranceLookup_v02 />} />
                      <Route path="/insurancelookup3" element={<InsuranceLookup_v03 />} />
                      <Route path="/insurancelookup4" element={<InsuranceLookup_v04 />} />
                      {/* NOT SURE ABOUT 5  */}
                      <Route path="/insurancelookup5" element={<InsuranceLookup_v05 />} />


                    

                      <Route path="/testC" element={<ContactFormWithCaptcha_TEST />} />
                        

                      <Route path="/requestquote" element={<InsuranceQuoteForm />} />

                      {/* <Route path="/insuranceQuote01" element={<InsuranceQuoteForm_Gemini_v01 />} /> */}
                        

                        {/* <Route path="/duiwizard" element={<DUI_QuoteWizard_v01g />} />
                      <Route path="/duiwizard-h7" element={<ExampleDuiQuoteWizard_H7 />} />
                      <Route path="/duiwizard-h8" element={<ExampleDuiQuoteWizard_H8 />} /> */}

                      
                      
{/* 
                      <Route path="/duiwizard-h9" element={<ExampleQuoteWizard_H9 />} />
                      <Route path="/duiwizard-h10" element={<AutoDUI_QuoteWizard_H10 />} />
 */}


                      <Route path="/auto" element={<AutoDUI_QuoteWizard_H11a />} />
                      <Route path="/motorcycle" element={<Motorcycle_QuoteWizard_H2a />} />


                      {/* 
                      <Route path="/contractor-v02" element={<ExampleContractorWizard_C2 />} />
                      <Route path="/contractor-painting-v01" element={<ExamplePaintingWizard_P1 />} />
                      <Route path="/contractor-painting-landing-v01" element={<PaintingContractorInsuranceLanding />} /> 
                      */}

                      

                      {/* <Route path="/restaurant" element={<RestaurantFeedbackWizard_H11aStyled />} /> */}
                      {/* <Route path="/autoshop" element={<AutoShopFeedbackWizard_H11bStyled />} /> */}
                      
                      
                      

                      <Route path="/rentersH2" element={<Renters_QuoteWizard_H2 />} />
                      <Route path="/rentersV2" element={<Renters_Insurance_v02 />} />

                      <Route path="/rentersV3" element={<Renters_Insurance_v03 />} />
                      <Route path="/renterslanding" element={<RentersInsuranceLandingPage_v01 />} />
    


                      <Route path="/mapdemo" element={<USMapInteractive />} />
                      <Route path="/vending" element={<VendingInterest_v03 />} />


                      {/* <Route path="/duilanding" element={<EasyDuiLandingPage_v01 />} />
                      <Route path="/duilanding2" element={<EASY_DUI_LandingPage_v02 />} />
                      <Route path="/duilanding2a" element={<EASY_DUI_LandingPage_v02a />} />
                      <Route path="/duilanding2b" element={<EASY_DUI_LandingPage_v02b />} />
                      <Route path="/duilanding2c" element={<EASY_DUI_LandingPage_v02c />} />
                       <Route path="/duilanding2cWIZARD" element={<EASY_DUI_LandingPage_v02c_WIZARD />} />
                       <Route path="/duilanding2dWIZARD" element={<EASY_DUI_LandingPage_v02d_WIZARD />} />
                       <Route path="/duilanding2eWIZARD" element={<EASY_DUI_LandingPage_v02e_WIZARD />} />
                       <Route path="/duilanding2fWIZARD" element={<EASY_DUI_LandingPage_v02f_WIZARD />} />
                       <Route path="/duilanding2gWIZARD" element={<EASY_DUI_LandingPage_v02g_WIZARD />} />

                       <Route path="/duilanding2kWIZARD" element={<EASY_DUI_LandingPage_v02K_WIZARD />} />
                       
                      */}

                
                      <Route path="/duilanding2hWIZARD" element={<EASY_DUI_LandingPage_v02h_WIZARD />} />
                      <Route path="/duibenefits01" element={<DUIInsurance_Benefits_v01 />} />




                       
                       {/* <Route path="/rentersv01h" element={<EASY_RENTERS_LandingPage_v01_WIZARD />} />
                       <Route path="/rentersv01i" element={<EASY_RENTERS_LandingPage_v02i_WIZARD />} />
                       <Route path="/rentersv01j" element={<EASY_RENTERS_LandingPage_v02j_WIZARD />} />

                       <Route path="/rentersv01k" element={<EASY_RENTERS_LandingPage_v02k_WIZARD />} />
                       <Route path="/rentersv01L" element={<EASY_RENTERS_LandingPage_v02L_WIZARD />} />
                       <Route path="/rentersv01M" element={<EASY_RENTERS_LandingPage_v02M_WIZARD />} />
                       <Route path="/rentersv01N" element={<EASY_RENTERS_LandingPage_v02N_WIZARD />} />
                       <Route path="/rentersv01O" element={<EASY_RENTERS_LandingPage_v02O_WIZARD />} />
                        */}
                       
                       
                       <Route path="/rentersO" element={<EASY_RENTERS_LandingPage_v02O_WIZARD />} />
                       <Route path="/rentersP" element={<EASY_RENTERS_LandingPage_v02P_WIZARD />} />
                       <Route path="/renters" element={<EASY_RENTERS_LandingPage_v02O_01_WIZARD />} />



                      <Route path="/duiwizard-h10" element={<AutoDUI_QuoteWizard_H10 />} />
                      
                      <Route path="/dui4" element={<DUI_InsuranceLanding_v04_Carousel />} />
                      <Route path="/dui5" element={<DUIInsuranceLandingPage_v05 />} />

                       <Route path="/dui" element={<EASY_DUI_LandingPage_v02K_WIZARD />} />
                       

                       {/* THIS IS FOR AN ACTUAL PAINTING JOB */}
                       <Route path="/painters" element={<EASY_PAINTING_LandingPage_v02O_WIZARD />} />

                       <Route path="/discountpainters" element={<DISCOUNT_PAINTERS_LandingPage_v01_WIZARD />} />

                      
                       


                       <Route path="/welding_v01" element={<DISCOUNT_WELDING_LandingPage_v020_WIZARD />} />
                       <Route path="/weldingb" element={<DISCOUNT_WELDING_LandingPage_v020b_WIZARD />} />
                       
                       <Route path="/welding" element={<DISCOUNT_WELDING_LandingPage_v020_WIZARD />} />
                       <Route path="/jewelry" element={<DISCOUNT_JEWELRY_Landing_v020_WIZARD />} />
                       <Route path="/plumbers" element={<DISCOUNT_PLUMBERS_LandingPage_v02O_WIZARD />} />

                       
                       <Route path="/SOLARv01" element={<CERTIFIED_SOLAR_REPORT_Landing_v02O_WIZARD />} />

                       {/* LATEST VERSION OF SOLAR COMPONENT */}
                       <Route path="/SOLAR" element={<SOLAR_5080_LandingPage_v01 />} />



                       <Route path="/parking" element={<DENVER_ParkingLotStriping_Landing_v01_WIZARD />} />


                       {/* CONTRACTOR */}
                      <Route path="/contractor0" element={<Contractor_QuoteWizard_H2 />} />
                      <Route path="/contractorA" element={<Contractor_QuoteWizard_H2_A />} />
                      <Route path="/contractorB" element={<Contractor_QuoteWizard_H2_B />} />
                      <Route path="/contractor-v01" element={<ExampleContractorWizard_C1 />} />
                      


                       <Route path="/contractor1" element={<EASY_CONTRACTOR_LandingPage_v02O_WIZARD />} />
                       <Route path="/contractor2" element={<DISCOUNT_CONTRACTOR_LandingPage_v02K_WIZARD />} />
                      
                       <Route path="/easycontractor" element={<EASY_CONTRACTOR_LandingPage_v01_WIZARD />} />
                       <Route path="/contractor03" element={<EASY_CONTRACTOR_LandingPage_v03 />} />
                       <Route path="/contractor03a" element={<EASY_CONTRACTOR_LandingPage_v03a />} />
                       <Route path="/contractor03b" element={<EASY_CONTRACTOR_LandingPage_v03b />} />



                        
                       <Route path="/hottubq" element={<HotTubQuiz_Landing_v01 />} />

                        <Route path="/electrician" element={<DISCOUNT_ELECTRICIAN_LandingPage_v020c_WIZARD />} />
                        <Route path="/plumber" element={<DISCOUNT_PLUMBERS_LandingPage_v02O_WIZARD />} />


                        <Route path="/demostep" element={<FourStepWizardForm_v01 />} />
                      

                 


                      <Route path="/easylanding" element={<EasyButtonInsuranceLandingPage_v01 />} />


                    <Route path="/salesforce" element={<DenverSalesforceLandingPage_v01 />} />
                    <Route path="/5280solar" element={<SOLAR_5280_LandingPage_v01 />} />
                    
                    
                    
                    <Route path="/pet" element={<DollarPetInsuranceLanding_v02 />} />
                    <Route path="/pet3" element={<PetInsuranceLanding_v03_Carousel />} />
                    <Route path="/pet3a" element={ <PetInsuranceLanding_v03a_Carousel />} />
                    <Route path="/pet4" element={ <PetInsuranceLanding_v04_Carousel />} />
                    <Route path="/pet5" element={ <PetInsuranceLanding_v05_Carousel />} />

                    <Route path="/pettopics" element={ <PET_Insurance_TOPICS_Page_Example_v01 />} />




                      
                    




                    <Route path="/shopper" element={<SecretShopperTeamLanding_v01 />} />


                     <Route path="/reactdemotabs" element={<ReactFourTabs_v01 />} />


                     <Route path="/reactdemotabnavheaderfooter" element={<React_Tabs_v01_NavHeaderFooter />} />


                    <Route path="/reactdemopagev03" element={<TabsWithLeftOffcanvas_v03 />} />
                    <Route path="/reactdemopagev04" element={<TabsWithLeftOffcanvas_v04 />} />

                    <Route path="/powerwash" element={<PowerWashLandingCarousel_v01 />} />
                    <Route path="/powerwash5" element={<PowerWashingLanding_v05_Carousel />} />




                    <Route path="/tax1" element={<TAX_DeepDive_Landing_v05_Carousel />} />
                    <Route path="/tax" element={<TAX_DEEP_DIVE_LandingPage_v02O />} />

                    <Route path="/insurance" element={<INSURANCE_WizardLanding_v01 />} />
                    
                    
                    <Route path="/wiz01" element={<WIZARD_RightToLeft_v01 />} />
                    <Route path="/wiz02" element={<WIZARD_RightToLeft_v02 />} />
                    <Route path="/wiz03" element={<WIZARD_RightToLeft_v03 />} />
                    <Route path="/wiz04" element={<WIZARD_RightToLeft_v04 />} />
                    <Route path="/wiz05" element={<WIZARD_RightToLeft_v05 />} />
                    <Route path="/wiz06" element={<WIZARD_RightToLeft_v06 />} />
                    <Route path="/wiz06auto" element={<AUTO_Insurance_Wizard_v06 />} />
                    <Route path="/wiz06home" element={<HOME_Insurance_Wizard_v06 />} />
                    <Route path="/wiz06homeA" element={<HOME_Insurance_Wizard_v06a_Themes theme="midnight"/>} />
                    <Route path="/wiz06homeB" element={<HOME_Insurance_Wizard_v06b_Themes theme="ocean"/>} />

                    

                    <Route path="/flashcard01" element={<FLASH_CARD_APP />} />


                    <Route path="/EasyLaundryRental" element={<AppEasyLaundryRental />} />
                    <Route path="/MortgageReadyScoreCard" element={<MortgageReadyScoreCardLandingPage_2025_11_06 />} />

                    <Route path="/divorceready" element={<DivorceReadyScoreCardLandingPage_2025_11_07_chat />} />
                    
                    <Route path="/joeaws" element={<AWSConsultantLanding_2025_11_07 />} />


                    <Route path="/easyemail" element={<EasyEmailSetupLanding_2025_11_07_chat />} />
                  

                    <Route path="/truecustomer" element={<TrueLifetimeCustomerLandingPage_2025_11_30_chat />} />
                  

                                  <Route
                                  path="/hvac"
                                  element={
                                    <InsuranceCard_v01
                                      data={hvacInsurance}
                                      imageUrl="https://images.unsplash.com/photo-1581092919535-6a2b2f4d3d23"
                                      imageAlt="HVAC technician at work"
                                    />   
                                    }
                                    /> 
                      




                      {/* SANTA LETTERS */}
                      <Route path="/santa01" element={<SantasWorkshopLetter />} />
                      <Route path="/santag01" element={<App_Santa_v01 />} />
                      <Route path="/santag02" element={<App_Santa_v02 />} />



                       <Route path="/taxchecklist" element={<TaxChecklist />} />


                       {/* <Route path="/mortgage01" element={<MortgageReadyScoreCardLanding_chat_05 />} />
                       <Route path="/mortgage01a" element={<MortgageReadyScoreCardLanding_v01a />} />
                       <Route path="/autoinsurance01" element={<AutoInsuranceScoreCardLanding_v01_chat />} /> */}
                       
                        

                      {/* 10-26-2025 */}
                       <Route path="/mythbuster01" element={<MythVsFactCarInsuranceQuizWizard_v01 />} /> 


                       <Route path="/bigpostcard" element={<BigPostcardLandingPage_2025_11_21_chat />} /> 

                      <Route path="/bouncehouse" element={<BounceHouseLandingPage_2025_11_21_chat />} /> 
                      <Route path="/bouncehouseres" element={<BounceHouseReservationPage_2025_11_21_chat />} /> 

                      <Route path="/autofunnel" element={<AutoInsuranceQuoteFunnel_2025_11_27_chat />} /> 


                      {/* <Route path="/awsfan" element={<AWSFanClubLandingPage_2025_09_12 />} />  */}

                      <Route path="/awslead" element={<AWSLeadershipTeam_LandingPage_2025_12_09_Chat />} /> 

                      <Route path="/voice" element={<Landing365AnsweringService_2025_12_10_chat />} /> 

                      <Route path="/bingo" element={<BingoGamePrint_2025_12_11_chat_v01 />} /> 
                      
                      {/* <Route path="/voicec" element={<VoiceAgent365LandingPage_2025_12_15 />} /> 
                      <Route path="/voicec2" element={<VoiceAgent365LandingPage_2025_12_15_chat_v02 />} /> 
                      <Route path="/voicec3" element={<VoiceAgent365LandingPage_2025_12_15_chat_v03 />} /> 
                      <Route path="/voicec4" element={<VoiceAgent365LandingPage_2025_12_15_chat_v04 />} /> 
                      <Route path="/voicec5" element={<VoiceAgent365LandingPage_2025_12_15_chat_v05 />} /> 

                      <Route path="/voicec5api" element={<VoiceAgent365LandingPage_2025_12_15_chat_v05_api />} /> 
                       */}

                      
                      
                      {/* 
                      <Route path="/voicec6" element={<VoiceAgent365LandingPage_2025_12_15_chat_v06 />} /> 
                      <Route path="/voicec7" element={<VoiceAgent365LandingPage_2025_12_15_chat_v07 />} />  
                      */}
                      


                      
                      {/* <Route path="/voiceg" element={<LandingPage_2025_12_15_gemini appName="VoiceAgent365"/>} />  */}

                      <Route path="/easytrash" element={<EasyTrashOutLandingPage_10_06_2025/>} /> 

                    
                                   
                      {/* <Route path="/aboutUs" element={<AboutLegacyInsurance />} /> */}
                      {/* <Route path="/aboutUs2" element={<AboutLegacyInsurance_v02 />} /> */}
                      {/* <Route path="/about" element={<AboutLegacyInsurance_v03 />} /> */}
                      
                      {/* <Route path="/faq2" element={<theVendingFAQ_v02a />} /> */}
                      
                  </Routes>
                </main>
                <Footer appConfig={AppConfig_DATA}/>
              </div>
    </Router>
  );
};





// const App_v01: React.FC = () => {
//   return (
//     <Router>
//       <Routes>
//         <Route path="/" element={<HomePage_v01 />} />
//         <Route path="/about" element={<About_v01 />} />
//         <Route path="/services" element={<Services_v01 />} />
//         <Route path="/contact" element={<Contact_v01 />} />
//         <Route path="/faq" element={<FAQs_Page_v01 />} />
//         <Route path="/leftnav" element={<LeftSideNavScrollSpy_v03 />} />\
//         <Route path="/googleSPDemov01" element={<LeftSideNavScrollSpy_v03 />} />
       
//       </Routes>
//     </Router>
//   );
// };

export default AppRouts_v01;
